import { createFileRoute } from "@tanstack/react-router";
import { SiteEditorPage } from "../../features/site/site-editor-page";

export const Route = createFileRoute("/restaurants/$restaurantId_/site")({ component: Page });

function Page() {
	const { restaurantId } = Route.useParams();
	return <SiteEditorPage key={restaurantId} restaurantId={restaurantId} />;
}
